import * as React from "react";
import { HoverableImage } from "../../components/HoverableImage/HoverableImage";
import { theModernArtisanPhotos } from "../../constants/photos";
import styles from "./TheModernArtisan.module.css";

const TheModernArtisan = () => {
  const gallery = theModernArtisanPhotos.map((image) => (
    <HoverableImage
      src={image.src}
      infoTitle={image.infoTitle}
      infoDescription={image.infoDescription}
      isFullWidth={image.isFull}
    />
  ));

  return (
    <>
      <h2 className={styles.title}>The Modern Artisan <br></br> Net-A-Porter x The King's Foundation</h2>
      <p className={styles.description}>
        One of six international designers selected for The Modern Artisan talent programme, developed by The King’s Foundation in partnership with YOOX NET-A-PORTER. Over nine months, I contributed to the full development of a responsible luxury womenswear collection, from concept, customer research and range development to fittings, sustainable sourcing and small-batch atelier production at Dumfries House. Working closely with NET-A-PORTER’s buying and product teams, I explored how heritage craftsmanship, circular design and commercial considerations could coexist within a contemporary luxury collection. One of my designs became the collection’s best-selling piece following its launch on NET-A-PORTER.
      </p>
      <div className={styles.galleryContainer}>
        <div className={styles.desktopGalleryContainer}>{gallery}</div>
        <div className={styles.mobileGalleryContainer}>{gallery}</div>
      </div>
    </>
  );
};

export default TheModernArtisan;
